import SearchComponent from '@components/Default/Search/SearchComponent';
import AppContext from '@services/Context';
import { Button, Col, Divider, Icon, Modal, Row, Spin } from 'antd';
import React from 'react';

import I18n from '../i18n';
import styled from '../styled-components';
import Table from './TableComponent';

type PropType = {
  loadingAvailableData: boolean;
  loadingMoreAvailableData: boolean;
  loadingMoreSavedData: boolean;
  loadingSavedData: boolean;
  onItemRemoved: Function;
  onItemSelected: Function;
  onLoadMoreAvailableData: Function;
  onLoadMoreSavedData: Function;
  onSearchAvailableUsers: Function;
  onSearchSavedUsers: Function;
  onToggleFormModal: Function,
  searchAvailableUsersValue: string;
  searchSavedUsersValue: string;
  serverResponse: any;
  showModal: boolean;
  showMoreAvailableData: boolean;
  showMoreSavedData: boolean;
  title: string;
  usersAvailableData: any[];
  usersAvailableTableColumns: any[];
  usersSavedData: any[];
  usersSavedTableColums: any[];
};

type StateType = {
  dataFormatted: boolean;
  selectedRowKeys: any[],
};

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class SelectableUnitUserComponent extends React.Component<PropType, StateType> {

  constructor(props: any) {
    super(props);

    this.state = {
      dataFormatted: false,
      selectedRowKeys: [],
    }
  }

  onSelectedRowKeysAvailableChanged = async (selectedRowKeys: any) => {
    this.setState({ selectedRowKeys });
    this.forceUpdate();
    this.processAvailableIdFromSelected(selectedRowKeys);
  }

  processAvailableIdFromSelected(selectedRowKeys: any) {
    const { usersAvailableData } = this.props;

    let id = undefined;
    if (selectedRowKeys !== undefined) {
      id = usersAvailableData.find(r => r.id === selectedRowKeys[0]).id
    }
    if (!!id) {
      this.props.onItemSelected(id);
    }
  }

  //#region RENDER
  renderAvailableUsers = () => {
    const { usersAvailableTableColumns } = this.props;
    const { selectedRowKeys } = this.state;

    const rowSelection = {
      selectedRowKeys,
      type: "radio",
      onChange: this.onSelectedRowKeysAvailableChanged,
    };

    return (
      <Row>
        <Table
          columns={usersAvailableTableColumns}
          data={this.formatAvailableDataToTable()}
          noPagination={true}
          showConfirmationModal={false}
          rowSelection={rowSelection}
        />
      </Row>
    )
  }

  formatAvailableDataToTable() {
    const { usersAvailableData } = this.props;
    const nextTableData: any[] = [];

    if (!!usersAvailableData && usersAvailableData.length > 0) {
      usersAvailableData.map((item: any, i: number) => {
        const loadingInfo = (item.loading === true) ? <Spin indicator={antIcon} /> : <div></div>
        nextTableData.push({
          ...usersAvailableData[i],
        });
        nextTableData[i].key = i;
        nextTableData[i].loading = loadingInfo;
      });

      return nextTableData;
    }
    return [];
  }

  renderSavedUsers() {
    const { usersSavedTableColums } = this.props;
    return (
      <Row>
        <Table
          columns={usersSavedTableColums}
          data={this.formatSavedDataToTable()}
          noPagination={true}
          showConfirmationModal={false}
        />
      </Row >
    )
  }

  formatSavedDataToTable() {
    const { usersSavedData } = this.props;

    if (!!usersSavedData && usersSavedData.length > 0) {
      const nextTableData: any[] = [];

      usersSavedData.map((item: any, i: number) => {
        const loadingInfo =
          item.loading === true ?
            <Spin indicator={antIcon} />
            :
            <Icon
              style={{ color: 'red' }}
              className="dynamic-delete-button goepik-delete-icon"
              type="close"
              onClick={() => this.props.onItemRemoved(item.id)}
            />
        nextTableData.push({
          ...usersSavedData[i],
        })
        nextTableData[i].loading = loadingInfo;
        nextTableData[i].key = i;
      })
      return nextTableData;
    }
    return [];
  }

  renderDataDivider() {
    return (
      <Col md={1} lg={1} offset={1} className="goepik-component-padding">
        <span>
          <Divider type="vertical" />
        </span>
      </Col>
    )
  }

  saveAvailableUserDone = async () => {
    this.setState({ selectedRowKeys: [] });
  }

  //#endregion
  //#region USER INPUT
  userCardClicked(id: string) {
    this.props.onItemSelected(id)
  }
  //#endregion

  render() {
    const {
      title,
      usersAvailableData,
      usersSavedData,
      loadingAvailableData,
      loadingSavedData,
      onToggleFormModal,
      showModal,
      searchAvailableUsersValue,
      searchSavedUsersValue,
      loadingMoreAvailableData,
      loadingMoreSavedData,
      showMoreAvailableData,
      showMoreSavedData
    } = this.props;

    return (
      <AppContext.Consumer>
        {({ theme, locale }) => (
          <Wrapper>
            <LargeModal>
              <Modal width="90%" visible={showModal} footer={false} closable={false} >
                <ModalTitle>{title}</ModalTitle>
                <ModalContent className="goepik-component-padding">
                  <Row className={"content-holder"}>
                    <Col md={11}>
                      <Row >
                        <p className="subtitle">{I18n.l('table.units.availableUsers')}</p>
                      </Row>
                      {loadingAvailableData && (
                        <p className="goepik-medium-top-margin">{I18n.l('units.loadingUsers')}</p>
                      )}
                      {loadingAvailableData == false &&
                        (
                          <div>
                            <Row className="goepik-small-top-margin">
                              <SearchComponent
                                onSubmit={this.props.onSearchAvailableUsers}
                                placeholder='form.placeholders.unitUserSearch'
                                defaultValue={searchAvailableUsersValue}
                                buttonText='form.buttons.search'
                              />
                            </Row>
                            {(usersAvailableData.length > 0) && (
                              <>
                                <div>
                                  <TableWrapper>
                                    {this.renderAvailableUsers()}
                                  </TableWrapper>
                                </div>
                                {showMoreAvailableData && (
                                  <Button
                                    className="loading-more goepik-medium-top-margin"
                                    type="primary"
                                    size='large'
                                    ghost
                                    loading={loadingMoreAvailableData}
                                    onClick={() => this.props.onLoadMoreAvailableData()}>
                                    {I18n.l('common.seeMore')}
                                  </Button>
                                )}
                              </>
                            )}
                            {(usersAvailableData == undefined || usersAvailableData.length == 0) && (
                              <p className="goepik-component-padding">{I18n.l('units.labels.noUsersAvailabelToAssign')}</p>
                            )}
                          </div>
                        )
                      }
                    </Col>

                    {this.renderDataDivider()}

                    <Col md={11}>
                      <Row >
                        <p className="subtitle">{I18n.l('table.units.linkedUsers')}</p>
                      </Row>
                      {loadingSavedData && (
                        <p className="goepik-medium-top-margin">{I18n.l('units.loadingSavedUsers')}</p>
                      )}
                      {loadingSavedData == false &&
                        (
                          <div>
                            <Row className="goepik-small-top-margin">
                              <SearchComponent
                                onSubmit={this.props.onSearchSavedUsers}
                                placeholder='form.placeholders.unitUserSearch'
                                defaultValue={searchSavedUsersValue}
                                buttonText='form.buttons.search'
                              />
                            </Row>
                            {(usersSavedData.length > 0) && (
                              <>
                                <div>
                                  <TableWrapper>
                                    {this.renderSavedUsers()}
                                  </TableWrapper>
                                </div>
                                {showMoreSavedData && (
                                  <Button
                                    className="loading-more goepik-medium-top-margin"
                                    type="primary"
                                    size='large'
                                    ghost
                                    loading={loadingMoreSavedData}
                                    onClick={() => this.props.onLoadMoreSavedData()}>{I18n.l('common.seeMore')}</Button>
                                )}
                              </>
                            )}
                            {(usersSavedData == undefined || usersSavedData.length == 0) && (
                              <p className="goepik-component-padding">{I18n.l('units.labels.noUsersAssignedToAudit')}</p>
                            )}
                          </div>
                        )
                      }
                    </Col>
                  </Row>


                  <div className="goepik-extra-big-top-margin">
                    <Row type="flex" justify="end">
                      <Button className="main-button" type="primary" ghost size="large" onClick={() => onToggleFormModal()}>
                        {I18n.l('common.close')}
                      </Button>
                    </Row>
                  </div>
                </ModalContent>
              </Modal>
            </LargeModal>
          </Wrapper>
        )}
      </AppContext.Consumer>
    );
  }
}

const LargeModal = styled.div`
    .ant-modal{
        width: 75%; !important
        height: 300px;
    }
`;

const ModalTitle = styled.h3`
    font-size: 16px;
    font-weight: bold;
`;

const ModalContent = styled.div`
    .content-holder{
        height: 390px;
    }

    .subtitle{
        font-size: 15px;
        font-weight: bold;
    }    

    .audits-saved-title{
        font-weight: bold;
    }
    .goepik-delete-icon:hover{
        cursor:pointer;
    }

    .goepik-component-padding{
        color:#a3a3a3;
        font-weight:bold;
        font-size:14px;
    }
    .main-button {
        font-weight: bold;
        text-transform: uppercase;
        font-size:15px;
    }
    .searchBtn{
        border-color: #1890ff;
        color: #1890ff;
    }
    .margied-elements{
        margin-left:10px;
    }
    .ant-divider, .ant-divider-vertical{
        height: 395px;
        margin-top: 1px;
    }
`;

const TableWrapper = styled.div`
    overflow-y:auto;
    max-height: 280px;
    margin-top: 28px;

    .selectable-row{
        cursor: pointer;
    }
    .locked-row{
        cursor: not-allowed;
    }
  ::-webkit-scrollbar {
      -webkit-appearance: none;
  }
  
  ::-webkit-scrollbar:vertical {
      width: 11px;
  }
  
  ::-webkit-scrollbar:horizontal {
      height: 11px;
  }
  
  ::-webkit-scrollbar-thumb {
      border-radius: 8px;
      border: 2px solid white; /* should match background, can't be transparent */
      background-color: rgba(0, 0, 0, .5);
  }
  
  ::-webkit-scrollbar-track { 
      background-color: #fff; 
      border-radius: 8px; 
  } 

`

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column;
    overflow-x: auto;
    width: 100%;

    .ant-table-wrapper {
            width: 99.9%;

            button {
                border: 0;
            }
    }

    .action-buttons {
        display: block;
        text-align: right;
        button {
        margin: 0 0 3px 0px;
        padding: 3px;
        width: 70px; 
        }
    
    }

    table {
        td {
            .disabled {
                color: #ccc;
            }
        }
    }
`;

export default SelectableUnitUserComponent;
